import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0414 from "../lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4d86e5c9-eb23-4959-874a-ecca19f4bb7a",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0414),
    lesson: lesson0414,
  },
];

export default lessonLinks;
